<template>
    <div class="winner_grids" v-if="attached_grids.length > 0">
        <div class="grid_winner mb-4"
             style="display: block;width:100%"
             :id="grid.id" :key="'grid_' + grid.id" v-for="grid in attached_grids">
        </div>
    </div>
    <div class="empty" v-else>
        <div class="text-center text-muted py-5 border rounded">
            <i class="far fa-folder-open fa-2x d-block mb-2"></i>
                Позиції не розподілені
        </div>
    </div>
    
    <div id="positions_control" style="width: 100%; ">
        <div class="row">
            <div class="col-6">
                <div class="btn btn-outline-primary btn_auto_render mb-2 mt-2 waves-effect waves-themed" v-on:click="auto_distribute">Розподілити</div>
            </div>
        </div>
    </div>
    
</template>


<script>

import * as W2 from 'w2ui'

window.w2ui    = W2.w2ui
window.w2grid  = W2.w2grid
window.w2field = W2.w2field
window.query   = W2.query
window.w2utils = W2.w2utils
window.w2popup = W2.w2popup

export default {
    name: "protocol_winners",
    
    props : {
        protocol : {
            type : Object
        }
    },
    
    mounted() {
        this.$nextTick(() => this.initGrids())
    },
    
    created() {
        
        EventBus.$on('push_new_grid', () => {
            this.$nextTick(() => this.initGrids())
        });
        
        EventBus.$on('push_grid_position', ({ grid, record }) => {
            if (w2ui[grid]) {
                w2ui[grid].add({ ...record })
                
                this.recalcHeight(grid);
            }
        })
        
        EventBus.$on('winners:reset', () => {
            this.$nextTick(() => this.destroyGrids())
        });
        
        EventBus.$on('tab-shown', (key) => {
            if (key === 'protocol_winners') {
                this.$nextTick(() => {
                    requestAnimationFrame(() => {
                        this.attached_grids.forEach(g => {
                            w2ui[g.id]?.resize()
                            w2ui[g.id]?.refresh()
                        })
                    })
                })
            }
        });
    },
    
    methods : {
        
        auto_distribute() {
            EventBus.$emit('winners:auto_distribute');
        },
        
        
        destroyGrids() {
            if (window.w2ui) {
                Object.keys(w2ui).forEach((name) => {
                    if (name.startsWith('app')) {
                        try { w2ui[name].destroy(); } catch (e) {}
                        const el = document.getElementById(name);
                        if (el) el.remove();
                    }
                });
            }
            
            this.protocol.position_grid_add = [];
        },
        
        initGrids() {
            this.attached_grids.forEach(g => this.initGrid(g))
        },
        
        initGrid(grid) {
            const grid_id = grid.id
            let self = this;
            
            // контейнер должен существовать
            const $box = window.$('#' + grid_id)
            if ($box.length === 0) {
                return this.$nextTick(() => this.initGrid(grid))
            }
            
            if (w2ui[grid_id]) w2ui[grid_id].destroy()
            
            window.$().w2grid({
                name: grid_id,
                header: grid.title,
                show: { header: true, lineNumbers: true, toolbar: true, footer: true },
                columns: grid.columns,
                summary: grid.summary,
                records: grid.records_push,
                onDblClick: (event) => {
                    const recid = event.recid
                    self.onWinnerItemRemoved(grid_id,recid);
                }
            })
            
            const height = w2ui[grid_id].records.length * w2ui[grid_id].recordHeight + 255 + 'px'
            $box.height(height).w2render(grid_id);
            
            EventBus.$emit('grid_add', { grid: grid_id })
            w2ui[grid_id].resize();
            w2ui[grid_id].refresh()
           /* setTimeout(() => {
            
            }, 300);
         */
        },
        
        onWinnerItemRemoved( grid_id, recid ) {
            
            const rec   = w2ui[grid_id].get(recid)
            if (!rec) return
            
            console.log('remove_record',grid_id,recid);
            w2ui[grid_id].remove(recid)
            
            const bag = this.protocol.position_grid_add.find(b => b.id === grid_id)
            if (bag) bag.records_push = bag.records_push.filter(r => r.recid !== recid)
            
            const g = this.protocol.position_grid_add.find(x => x.id === grid_id);
            if (!g) return;
            
            g.records_push = g.records_push.filter(r =>
                String(r.recid) !== String(recid) && String(r.id) !== String(recid)
            );
            
            EventBus.$emit('winner_item_removed', { grid: grid_id, record: recid })
            
            if (g.records_push.length === 0) {
                console.log('destroy_grid',grid_id);
                if (w2ui[grid_id]) w2ui[grid_id].destroy();
                const idx = this.protocol.position_grid_add.findIndex(x => x.id === grid_id);
                if (idx > -1) this.protocol.position_grid_add.splice(idx, 1);
            }
            else {
                this.recalcHeight(grid_id)
            }
        },
        
        recalcHeight(grid_id) {
            const h = this.calcHeight(grid_id)
            window.$('#' + grid_id).height(h)
            w2ui[grid_id]?.refresh()
            w2ui[grid_id]?.resize()
        },
        
        calcHeight(grid_id) {
            const g = w2ui[grid_id]
            if (!g) return 255
            return (g.records.length * g.recordHeight + 255) + 'px'
        },
    },
    
    computed : {
        attached_grids () {
            return this.protocol.position_grid_add;
        },
    }
    
}
</script>


<style scoped>
.winners_position_block,
.grid_winner {
    width: 100%;
    display: block;
}
</style>